module.exports = __webpack_public_path__ + "img/papel-do-google-ads.f94df487.jpg";